module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "floating-basket"
    },
    on: {
      "click": _vm.goToBasket
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket"
  }), _vm._v(" "), _c('span', {
    staticClass: "bottom-badge"
  }, [_vm._v(_vm._s(_vm.basketCount))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffd8532e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FloatingBasket.vue
// module id = 216
// module chunks = 14